import { cva } from "class-variance-authority"

export const display = cva("font-buenosAires font-bold text-black -tracking-wider", {
  variants: {
    size: {
      "2xl": "text-7xl leading-20",
      xl: "text-6.5xl leading-18",
      lg: "text-5xl leading-14",
      md: "text-3.5xl leading-13",
      sm: "text-2xl leading-7",
      xs: "text-xl leading-6",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

export const title = cva("font-buenosAires font-bold text-black -tracking-wider", {
  variants: {
    size: {
      "2xl": "text-3.5xl leading-10",
      xl: "text-2.5xl leading-9",
      lg: "text-2xl leading-8",
      md: "text-xl leading-6",
      sm: "text-lg leading-6",
      xs: "text-base leading-5",
      xxs: "text-sm leading-4",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

export const body = cva("font-buenosAires font-bold text-black -tracking-medium", {
  variants: {
    size: {
      xl: "text-0.5xl leading-7",
      lg: "text-lg leading-6",
      md: "text-base leading-5",
      sm: "text-sm leading-4",
      link: "text-sm leading-5 underline",
    },
  },
  defaultVariants: {
    size: "md",
  },
})

export const paragraph = cva("font-sans font-medium text-black -tracking-medium", {
  variants: {
    size: {
      xl: "text-0.5xl leading-8",
      lg: "text-lg",
      md: "text-base",
      sm: "text-sm",
      xs: "text-xs leading-4.5",
    },
  },
  defaultVariants: {
    size: "md",
  },
})
